import { OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DataService } from '../_service/data.service';

declare const moment: any;
declare const $: any;

export abstract class FilterBaseComponent implements OnDestroy {

  // Dropdown Settings
  outletDropdownSettings: IDropdownSettings;
  parentDropdownSettings: IDropdownSettings;
  zoneDropdownSettings: IDropdownSettings;
  regionDropdownSettings: IDropdownSettings;
  columnDropdownSettings: IDropdownSettings;
  channelDropdownSettings: IDropdownSettings;
  outletTypeDropdownSettings: IDropdownSettings;

  // Lists
  public regionList: any = [];
  public zoneList: any = [];
  public parentList: any = [];
  public outletList: any = [];
  public columnList: any = [];
  public channelList: any = [];
  public outletTypeList: any = [];
  

  // Selected Values
  selectedZone = [];
  selectedRegion = [];
  selectedParent = [];
  selectedOutlet = [];
  selectedColumn = [];
  selectedChannel = [];
  selectedOutletType = [];

  // ngModel bindings
  zone = [];
  region = [];
  parent = [];
  outlet = [];
  channel = [];

  // API Request object
  apiReq = {
    zone: '',
    region: '',
    parent: '',
    outlet: '',
    channel: '',
    outletType: '',
    agl_flag: '',
  };

  // Flags
  zoneStatus: Boolean = false;
  isZoneTriggered: Boolean = false;
  regionStatus: Boolean = false;
  parentStatus: Boolean = false;
  outletStatus: Boolean = false;
  channelStatus: Boolean = false;
  firstTimeRun: Boolean = true;
  isParentTriggered: Boolean = false;

  // Misc
  channelName: any = '';
  outletTypeName: any = '';
  columnName: any;
  loginData: any;

  protected abstract advanceFilter(): void;
  protected abstract filterForm: FormGroup;

  constructor(protected dataService: DataService) {}

  protected getDefaultDateRange() {
  const today = moment();
  const isFirstOfMonth = today.date() === 1;

  const startDate = isFirstOfMonth
    ? today.clone().subtract(1, 'month').startOf('month')
    : today.clone().startOf('month');

  const endDate = isFirstOfMonth
    ? today.clone().subtract(1, 'month').endOf('month')
    : today.clone().subtract(1, 'day');

  return {
    startDate,
    endDate,
    formattedStartDate: startDate.format('YYYY-MM-DD'),
    formattedEndDate: endDate.format('YYYY-MM-DD'),
    maxDate: today.clone().subtract(1, 'day'),
  };
}

protected initializeDateRangePicker(
  callback?: Function
) {
  const dateRange = this.getDefaultDateRange();

  this.filterForm.patchValue({
    start_date: dateRange.formattedStartDate,
    end_date: dateRange.formattedEndDate,
  });

  let options = {
    timePicker: false,
    startDate: dateRange.startDate,
    endDate: dateRange.endDate,
    maxDate: dateRange.maxDate,
    maxSpan: { days: 30 },
    locale: {
      format: "DD MMM YYYY",
    },
  };

  const self = this;

  $('input[name="daterange_input"]').daterangepicker(
    options,
    function(start, end) {

      self.filterForm.controls["start_date"].setValue(
        moment(start).format("YYYY-MM-DD")
      );

      self.filterForm.controls["end_date"].setValue(
        moment(end).format("YYYY-MM-DD")
      );

      if (callback) {
        callback(start, end);
      }
    }
  );
}

protected isDefaultDateRange(): boolean {
  const dateRange = this.getDefaultDateRange();

  return (
    this.filterForm.value.start_date === dateRange.formattedStartDate &&
    this.filterForm.value.end_date === dateRange.formattedEndDate
  );
}

  // ─── Dropdown Settings ───────────────────────────────────────

  zoneSetting() {
    this.zoneDropdownSettings = {
      singleSelection: false, idField: 'zone', textField: 'zone',
      selectAllText: 'Select All', unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1, allowSearchFilter: true,
    };
  }

  regionSetting() {
    this.regionDropdownSettings = {
      singleSelection: false, idField: 'region', textField: 'region',
      selectAllText: 'Select All', unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1, allowSearchFilter: true,
    };
  }

  parentSetting() {
    this.parentDropdownSettings = {
      singleSelection: false, idField: 'business_unit_id', textField: 'parent',
      selectAllText: 'Select All', unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1, allowSearchFilter: true,
    };
  }

  outletSetting() {
    this.outletDropdownSettings = {
      singleSelection: false, idField: 'webform_id', textField: 'outlet',
      selectAllText: 'Select All', unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1, allowSearchFilter: true,
    };
  }

  columnSetting() {
    this.columnDropdownSettings = {
      singleSelection: false, idField: 'column_name', textField: 'view_name',
      selectAllText: 'Select All', unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1, allowSearchFilter: true,
    };
  }

  channelSetting() {
    this.channelDropdownSettings = {
      singleSelection: false, idField: 'channel', textField: 'channel',
      selectAllText: 'Select All', unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1, allowSearchFilter: true,
    };
  }

  outletTypeSetting() {
    this.outletTypeDropdownSettings = {
      singleSelection: false, idField: 'outlettype', textField: 'outlettype',
      selectAllText: 'Select All', unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1, allowSearchFilter: true,
    };
  }

  // ─── Zone Events ─────────────────────────────────────────────

// ─── Zone Events ─────────────────────────────────────────────

onZoneSelect(item: any) {
  this.isZoneTriggered = true;
  this.selectedZone.push(item.zone);
  const data = "'" + this.selectedZone.join("','") + "'";
  this.selectedRegion = []; this.region = []; this.apiReq.region = '';
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  this.apiReq.zone = data;
  this.getAllRegion(data);
}

onZoneAll(items: any) {
  this.isZoneTriggered = true;
  this.region = []; this.apiReq.region = '';
  this.selectedZone = []; this.selectedRegion = [];
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  items.forEach((i: any) => this.selectedZone.push(i.zone));
  const data = "'" + this.selectedZone.join("','") + "'";
  this.apiReq.zone = data;
  this.getAllRegion(data);
}

onZoneDeSelect(item: any) {
  this.selectedZone.splice(this.selectedZone.indexOf(item.zone), 1);
  const data = "'" + this.selectedZone.join("','") + "'";
  this.apiReq.zone = data;
  this.selectedRegion = []; this.region = []; this.apiReq.region = '';
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  this.isZoneTriggered = this.selectedZone.length > 0;
  this.getAllRegion(data);
}

onZoneDeAll() {
  this.selectedRegion = []; this.region = []; this.apiReq.region = '';
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  this.selectedZone = []; this.regionList = []; this.apiReq.zone = '';
  this.getAllRegion("''");
}

// ─── Region Events ───────────────────────────────────────────

onRegionSelect(item: any) {
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  this.selectedRegion.push(item.region);
  const data = "'" + this.region.map((r: any) => r.region).join("','") + "'";
  this.apiReq.region = data;
  this.getAllParent(data);
}

onRegionAll(items: any) {
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  const data = "'" + items.map((r: any) => r.region).join("','") + "'";
  this.apiReq.region = data;
  this.getAllParent(data);
}

onRegionDeSelect(item: any) {
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  const data = "'" + this.region.map((r: any) => r.region).join("','") + "'";
  this.apiReq.region = data;
  this.getAllParent(data);
}

onRegionDeAll() {
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  this.selectedRegion = []; this.region = [];
  this.parentList = []; this.apiReq.region = '';
  this.getAllParent("''");
}

// ─── Channel Events ──────────────────────────────────────────

onChannelSelect(item: any) {
  this.selectedChannel.push(item.channel);
  const data = "'" + this.selectedChannel.join("','") + "'";
  this.apiReq.channel = data; this.channelName = data;
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  this.getAllParent(this.apiReq.region);
}

onChannelAll(items: any) {
  this.selectedChannel = [];
  items.forEach((i: any) => this.selectedChannel.push(i.channel));
  const data = "'" + this.selectedChannel.join("','") + "'";
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  this.apiReq.channel = data; this.channelName = data;
  this.getAllParent(this.apiReq.region);
}

onChannelDeSelect(item: any) {
  this.selectedChannel.splice(this.selectedChannel.indexOf(item.channel), 1);
  const data = "'" + this.selectedChannel.join("','") + "'";
  this.apiReq.channel = data; this.channelName = data;
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  this.getAllParent(this.apiReq.region);
}

onChannelDeAll() {
  this.selectedChannel = [];
  // ← removed: selectedParent, parent, selectedOutlet, outlet reset
  this.parentList = [];
  this.apiReq.channel = ''; this.channelName = '';
  this.getAllParent(this.apiReq.region);
}
  // ─── Parent Events ───────────────────────────────────────────

  onParentSelect(item: any) {
    this.isParentTriggered = true;                        // ← set flag
    this.selectedParent.push(item.business_unit_id);
    const data = "'" + this.selectedParent.join("','") + "'";
    this.apiReq.parent = data;
    this.selectedOutlet = [];
    this.getAllOutlet(data);
  }

  onParentAll(items: any) {
    this.isParentTriggered = true;                        // ← set flag
    this.selectedParent = [];
    items.forEach((i: any) => this.selectedParent.push(i.business_unit_id));
    const data = "'" + this.selectedParent.join("','") + "'";
    this.selectedOutlet = []; this.apiReq.parent = data;
    this.getAllOutlet(data);
  }

  onParentDeSelect(item: any) {
    this.selectedParent.splice(this.selectedParent.indexOf(item.business_unit_id), 1);
    const data = "'" + this.selectedParent.join("','") + "'";
    this.apiReq.parent = data;
    this.selectedOutlet = [];
    // conditional — same as onZoneDeSelect
    this.isParentTriggered = this.selectedParent.length > 0;
    this.getAllOutlet(data);
  }

  onParentDeAll() {
    this.selectedParent = []; this.selectedOutlet = [];
    this.outletList = []; this.apiReq.parent = '';
    // isParentTriggered NOT set — outlets won't auto-select
    this.getAllOutlet("''");
  }

  // ─── Outlet Events ───────────────────────────────────────────

  onOutletSelect(item: any) {
  this.selectedOutlet.push(item.webform_id);
  // ─── FIX: also sync this.outlet ──────────────────────────────
  this.outlet.push({ webform_id: item.webform_id, outlet: item.outlet });
  this.apiReq.outlet = "'" + this.selectedOutlet.join("','") + "'";
  this.advanceFilter();
}

  onOutletAll(items: any) {
  this.selectedOutlet = [];
  items.forEach((i: any) => this.selectedOutlet.push(i.webform_id));
  // ─── FIX: also sync this.outlet ──────────────────────────────
  this.outlet = items.map((i: any) => ({ webform_id: i.webform_id, outlet: i.outlet }));
  this.apiReq.outlet = "'" + this.selectedOutlet.join("','") + "'";
  this.advanceFilter();
}

  onOutletDeSelect(item: any) {
  this.selectedOutlet.splice(this.selectedOutlet.indexOf(item.webform_id), 1);
  // ─── FIX: read from this.outlet (ngModel) not selectedOutlet ───
  const data = this.outlet.length
    ? "'" + this.outlet.map((o: any) => o.webform_id).join("','") + "'"
    : '';
  this.apiReq.outlet = data;
  this.advanceFilter();
}

  onOutletDeAll() {
  this.selectedOutlet = [];
  this.outlet = []; // ─── FIX: clear ngModel too ────────────────
  this.apiReq.outlet = '';
  this.advanceFilter();
}

  // ─── Outlet Type Events ──────────────────────────────────────

// ─── Outlet Type Events ──────────────────────────────────────

onOutletTypeSelect(item: any) {
  this.selectedOutletType.push(item.outlettype);
  const data = "'" + this.selectedOutletType.join("','") + "'";
  this.apiReq.outletType = data;
  this.outletTypeName = data;
  this.advanceFilter(); // ← just update payload & refresh dashboard
}

onOutletTypeAll(items: any) {
  this.selectedOutletType = [];
  items.forEach((i: any) => this.selectedOutletType.push(i.outlettype));
  const data = "'" + this.selectedOutletType.join("','") + "'";
  this.apiReq.outletType = data;
  this.outletTypeName = data;
  this.advanceFilter(); // ← just update payload & refresh dashboard
}

onOutletTypeDeSelect(item: any) {
  this.selectedOutletType.splice(this.selectedOutletType.indexOf(item.outlettype), 1);
  const data = "'" + this.selectedOutletType.join("','") + "'";
  this.apiReq.outletType = data;
  this.outletTypeName = data;
  this.advanceFilter(); // ← just update payload & refresh dashboard
}

onOutletTypeDeAll() {
  this.selectedOutletType = [];
  this.apiReq.outletType = '';
  this.outletTypeName = '';
  this.advanceFilter(); // ← just update payload & refresh dashboard
}
  // ─── Column Events ───────────────────────────────────────────

  onColumnSelect(item: any) { this.selectedColumn.push(item.column_name); }
  onColumnAll(items: any) {
    this.selectedColumn = [];
    items.forEach((i: any) => this.selectedColumn.push(i.column_name));
  }
  onColumnDeSelect(item: any) {
    this.selectedColumn.splice(this.selectedColumn.indexOf(item.column_name), 1);
  }
  onColumnDeAll() { this.selectedColumn = []; this.columnName = ''; }

  // ─── API Calls ───────────────────────────────────────────────

  public getAllZone() {
    this.dataService.startLoader();
    this.dataService.postMaster('filter/getZone', { loginInfo: this.buildLoginInfo() }).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res['code'] == 200) {
          this.zoneList = res['data'];
          const arr = this.zoneList.map((z: any) => z.zone);
          const data = "'" + arr.join("','") + "'";
          this.apiReq.zone = data;
          this.getAllRegion(data);
        } else { this.handleError(res); }
      },
      () => this.dataService.stopLoader()
    );
  }

  public getAllRegion(zoneName) {
    this.dataService.startLoader();
    let data: any = { loginInfo: this.buildLoginInfo(), zone: zoneName };
    if (this.loginData.userType === 8 || this.loginData.userType === 10) {
      data.zone = `'${this.loginData.zone}'`;
    }
    this.dataService.postMaster('filter/getRegion', data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res['code'] == 200) {
          this.regionList = res['data'];

          if (this.isZoneTriggered) {
            // Auto-select all regions when zone triggered
            this.region = this.regionList.map((r: any) => ({ region: r.region }));
            const arr = this.regionList.map((r: any) => r.region);
            this.apiReq.region = "'" + arr.join("','") + "'";
          } else {
            // Initial load — populate only, no auto-select
            this.region = []; this.apiReq.region = '';
          }

          this.isZoneTriggered = false; // ← reset ONCE here only

          this.selectedParent = []; this.selectedOutlet = [];
          this.apiReq.parent = ''; this.apiReq.outlet = '';

          const arr = this.regionList.map((r: any) => r.region);
          const regionData = this.apiReq.region || "'" + arr.join("','") + "'";
          this.getAllChannel(regionData);
        } else { this.handleError(res); }
      },
      () => this.dataService.stopLoader()
    );
  }

  public getAllChannel(regionName) {
    this.dataService.startLoader();
    this.dataService.postMaster('filter/getAllChannel', {
      loginInfo: this.buildLoginInfo(), region: regionName
    }).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res['code'] == 200) {
          this.channelList = res['data'];
          const arr = this.channelList.map((c: any) => c.channel);
          this.channelName = "'" + arr.join("','") + "'";
          this.getAllParent(regionName);
        } else { this.handleError(res); }
      },
      () => this.dataService.stopLoader()
    );
  }

  public getAllParent(regionName) {
  this.dataService.startLoader();
  let data: any = {
    loginInfo: this.buildLoginInfo(),
    region: this.loginData.userType === 6 ? `'${this.loginData.region}'` : regionName,
    channel: this.channelName,
  };
  this.dataService.postMaster('filter/getParent', data).subscribe(
    (res) => {
      this.dataService.stopLoader();
      if (res['code'] == 200) {
        this.parentList = res['data'];

        // ── Preserve existing parent selection if still valid ──
        if (this.selectedParent.length > 0) {
          const validIds = this.parentList.map((p: any) => p.business_unit_id);
          // Keep only parents that exist in the new list
          const stillValid = this.selectedParent.filter(id => validIds.includes(id));

          if (stillValid.length > 0) {
            this.selectedParent = stillValid;
            this.parent = this.parentList.filter((p: any) =>
              stillValid.includes(p.business_unit_id)
            );
            this.apiReq.parent = "'" + stillValid.join("','") + "'";
          } else {
            // None of previous selection is valid anymore — clear
            this.selectedParent = []; this.parent = []; this.apiReq.parent = '';
          }
        } else if (this.isParentTriggered) {
          // User just selected — keep as is
        } else {
          this.parent = []; this.apiReq.parent = '';
        }

        this.isParentTriggered = false;

        const arr = this.parentList.map((p: any) => p.business_unit_id);
        const parentData = this.apiReq.parent || "'" + arr.join("','") + "'";
        this.getAllOutletType(parentData);
      } else { this.handleError(res); }
    },
    () => this.dataService.stopLoader()
  );
}

public getAllOutlet(parentName) {
  this.dataService.startLoader();
  let data: any;
  if (this.loginData.userType === 2) {
    data = {
      loginInfo: this.buildLoginInfo(),
      region: this.apiReq.region,
      business_unit_id: this.loginData.business_unit_id,
      channel: this.channelName,
      outletType: this.outletTypeName,
      userType: this.loginData.userType,
    };
  } else {
    data = {
      loginInfo: this.buildLoginInfo(),
      parent: parentName,
      channel: this.channelName,
      outletType: this.outletTypeName,
      userType: this.loginData.userType,
    };
  }
  this.dataService.postMaster('filter/getOutlet', data).subscribe(
    (res) => {
      this.dataService.stopLoader();
      if (res['code'] == 200) {
        this.outletList = res['data'];

        if (this.isParentTriggered) {
          // Parent was just selected — auto-select ALL outlets
          this.outlet = this.outletList.map((o: any) => ({
            webform_id: o.webform_id, outlet: o.outlet,
          }));
          this.selectedOutlet = this.outletList.map((o: any) => o.webform_id);
          this.apiReq.outlet = "'" + this.selectedOutlet.join("','") + "'";

        } else if (this.selectedParent.length > 0) {
          // Parent is selected — smart merge:
          // keep valid existing selections + auto-select newly added outlets
          const newListIds = this.outletList.map((o: any) => o.webform_id);
          const previouslySelected = this.selectedOutlet;

          // Outlets that were selected and still exist → keep
          const stillValid = previouslySelected.filter((id: any) =>
            newListIds.includes(id)
          );

          // Outlets in new list that were NOT in previous selection
          // AND were not previously deselected by user → auto-select them
          // We detect "newly added" as: exists in new list but NOT in old outletList
          const previousListIds = this.outlet.map((o: any) => o.webform_id);
          const newlyAdded = newListIds.filter((id: any) =>
            !previousListIds.includes(id)
          );

          // Final selection = still valid + newly added
          const finalSelection = [...stillValid, ...newlyAdded];

          if (finalSelection.length > 0) {
            this.selectedOutlet = finalSelection;
            this.outlet = this.outletList.filter((o: any) =>
              finalSelection.includes(o.webform_id)
            );
            this.apiReq.outlet = "'" + finalSelection.join("','") + "'";
          } else {
            this.selectedOutlet = []; this.outlet = []; this.apiReq.outlet = '';
          }

        } else {
          // No parent selected — just populate list, no auto-select
          this.outlet = []; this.selectedOutlet = []; this.apiReq.outlet = '';
        }

        this.isParentTriggered = false;
        this.advanceFilter();
      } else { this.handleError(res); }
    },
    () => this.dataService.stopLoader()
  );
}
  public getAllOutletType(parentName) {
    this.dataService.startLoader();
    this.dataService.postMaster('filter/getAllOutletType', {
      loginInfo: this.buildLoginInfo(), region: parentName
    }).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res['code'] == 200) {
          this.outletTypeList = res['data'];
          const arr = this.outletTypeList.map((o: any) => o.channel);
          this.outletTypeName = "'" + arr.join("','") + "'";
          this.getAllOutlet(parentName);
        } else { this.handleError(res); }
      },
      () => this.dataService.stopLoader()
    );
  }

 

  public clearFilter() {
    this.dataService.removeCookies('hyperLocalFilter', '');
    this.selectedZone = []; this.selectedRegion = [];
    this.selectedParent = []; this.selectedChannel = [];
    this.selectedOutlet = [];
    window.location.reload();
  }

  // ─── Helpers ─────────────────────────────────────────────────

  protected buildLoginInfo() {
    return {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
    };
  }

  protected handleError(res: any) {
    this.dataService.showError(res['message']);
    if (res['code'] == 401) this.dataService.logout();
  }

  protected buildFinalData() {
    return {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      channel: this.apiReq.channel,
      agl_flag: this.apiReq.agl_flag,
      outletType: this.apiReq.outletType,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
    };
  }

  ngOnDestroy() {}
}